import { ApolloError } from "@apollo/client";

import { UserGuide, UserGuideMetadata } from "types/generated";

export const CERTIFICATE_DISPLAY_NAME_MAX_LENGTH = 50;

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof ApolloError && error.graphQLErrors.length > 0) {
    return error.graphQLErrors[0].message;
  }

  return "Something went wrong. Please try again.";
};

export const parseMinutes = (minutes: number) => {
  if (minutes < 60) {
    return `${minutes} min.`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (remainingMinutes === 0) {
    return `${hours} h`;
  }

  return `${hours} h ${remainingMinutes} min.`;
};

export const collectGroupTimeToComplete = (
  group: {
    chapters: Array<{
      guides: Array<
        Pick<UserGuide, "id"> & { metadata: Pick<UserGuideMetadata, "minutesToComplete"> }
      >;
    }>;
  },
  completedUserGuideIds: string[]
) => {
  return parseMinutes(
    group.chapters
      .flatMap((chapter) => chapter.guides)
      .reduce((acc, guide) => {
        if (completedUserGuideIds.includes(guide.id)) {
          return acc;
        }
        return acc + guide.metadata.minutesToComplete;
      }, 0)
  );
};

export const collectOverallTimeToComplete = (
  userGuideGroups: Array<{
    chapters: Array<{
      guides: Array<
        Pick<UserGuide, "id"> & { metadata: Pick<UserGuideMetadata, "minutesToComplete"> }
      >;
    }>;
  }>,
  completedUserGuideIds: string[]
) => {
  return parseMinutes(
    userGuideGroups
      .flatMap((group) => group.chapters.flatMap((chapter) => chapter.guides))
      .reduce((acc, guide) => {
        if (completedUserGuideIds.includes(guide.id)) {
          return acc;
        }
        return acc + guide.metadata.minutesToComplete;
      }, 0)
  );
};
